import { render, staticRenderFns } from "./ItemHashtagLayout.vue?vue&type=template&id=20c8a354&scoped=true"
import script from "./ItemHashtagLayout.vue?vue&type=script&lang=js"
export * from "./ItemHashtagLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8a354",
  null
  
)

export default component.exports